function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * @module ol/renderer/canvas/VectorTileLayer
 */
import CanvasBuilderGroup from '../../render/canvas/BuilderGroup.js';
import CanvasExecutorGroup, { DECLUTTER } from '../../render/canvas/ExecutorGroup.js';
import CanvasTileLayerRenderer from './TileLayer.js';
import TileState from '../../TileState.js';
import ViewHint from '../../ViewHint.js';
import ZIndexContext from '../../render/canvas/ZIndexContext.js';
import { HIT_DETECT_RESOLUTION, createHitDetectionImageData, hitDetect } from '../../render/canvas/hitdetect.js';
import { apply as applyTransform, create as createTransform, multiply, reset as resetTransform, scale, scale as scaleTransform, translate as translateTransform } from '../../transform.js';
import { ascending } from '../../array.js';
import { boundingExtent, buffer, containsExtent, equals, getIntersection, getTopLeft, intersects } from '../../extent.js';
import { getSquaredTolerance as getSquaredRenderTolerance, renderFeature as _renderFeature } from '../vector.js';
import { getUid } from '../../util.js';
import { toSize } from '../../size.js';
import { wrapX } from '../../coordinate.js';

/**
 * @type {!Object<string, Array<import("../../render/canvas.js").BuilderType>>}
 */
var IMAGE_REPLAYS = {
  'image': ['Polygon', 'Circle', 'LineString', 'Image', 'Text'],
  'hybrid': ['Polygon', 'LineString'],
  'vector': []
};

/**
 * @type {!Object<string, Array<import("../../render/canvas.js").BuilderType>>}
 */
var VECTOR_REPLAYS = {
  'hybrid': ['Image', 'Text', 'Default'],
  'vector': ['Polygon', 'Circle', 'LineString', 'Image', 'Text', 'Default']
};

/**
 * @classdesc
 * Canvas renderer for vector tile layers.
 * @api
 * @extends {CanvasTileLayerRenderer<import("../../layer/VectorTile.js").default>}
 */
var CanvasVectorTileLayerRenderer = /*#__PURE__*/function (_CanvasTileLayerRende) {
  /**
   * @param {import("../../layer/VectorTile.js").default} layer VectorTile layer.
   */
  function CanvasVectorTileLayerRenderer(layer) {
    var _this;
    _classCallCheck(this, CanvasVectorTileLayerRenderer);
    _this = _callSuper(this, CanvasVectorTileLayerRenderer, [layer]);

    /** @private */
    _this.boundHandleStyleImageChange_ = _this.handleStyleImageChange_.bind(_this);

    /**
     * @private
     * @type {number}
     */
    _this.renderedLayerRevision_;

    /**
     * @private
     * @type {import("../../transform").Transform}
     */
    _this.renderedPixelToCoordinateTransform_ = null;

    /**
     * @private
     * @type {number}
     */
    _this.renderedRotation_;

    /**
     * @private
     * @type {number}
     */
    _this.renderedOpacity_ = 1;

    /**
     * @private
     * @type {import("../../transform.js").Transform}
     */
    _this.tmpTransform_ = createTransform();

    /**
     * @private
     * @type {Array<ZIndexContext>}
     */
    _this.tileClipContexts_ = null;
    return _this;
  }

  /**
   * @param {import("../../VectorRenderTile.js").default} tile Tile.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../proj/Projection").default} projection Projection.
   * @return {boolean|undefined} Tile needs to be rendered.
   */
  _inherits(CanvasVectorTileLayerRenderer, _CanvasTileLayerRende);
  return _createClass(CanvasVectorTileLayerRenderer, [{
    key: "prepareTile",
    value: function prepareTile(tile, pixelRatio, projection) {
      var render;
      var state = tile.getState();
      if (state === TileState.LOADED || state === TileState.ERROR) {
        this.updateExecutorGroup_(tile, pixelRatio, projection);
        if (this.tileImageNeedsRender_(tile)) {
          render = true;
        }
      }
      return render;
    }

    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     * @return {!import("../../Tile.js").default} Tile.
     */
  }, {
    key: "getTile",
    value: function getTile(z, x, y, frameState) {
      var pixelRatio = frameState.pixelRatio;
      var viewState = frameState.viewState;
      var resolution = viewState.resolution;
      var projection = viewState.projection;
      var layer = this.getLayer();
      var tile = layer.getSource().getTile(z, x, y, pixelRatio, projection);
      var viewHints = frameState.viewHints;
      var hifi = !(viewHints[ViewHint.ANIMATING] || viewHints[ViewHint.INTERACTING]);
      if (hifi || !tile.wantedResolution) {
        tile.wantedResolution = resolution;
      }
      var render = this.prepareTile(tile, pixelRatio, projection);
      if (render && (hifi || Date.now() - frameState.time < 8) && layer.getRenderMode() !== 'vector') {
        this.renderTileImage_(tile, frameState);
      }
      return _superPropGet(CanvasVectorTileLayerRenderer, "getTile", this, 3)([z, x, y, frameState]);
    }

    /**
     * @param {import("../../VectorRenderTile.js").default} tile Tile.
     * @return {boolean} Tile is drawable.
     */
  }, {
    key: "isDrawableTile",
    value: function isDrawableTile(tile) {
      var layer = this.getLayer();
      return _superPropGet(CanvasVectorTileLayerRenderer, "isDrawableTile", this, 3)([tile]) && (layer.getRenderMode() === 'vector' ? getUid(layer) in tile.executorGroups : tile.hasContext(layer));
    }

    /**
     * @inheritDoc
     */
  }, {
    key: "getTileImage",
    value: function getTileImage(tile) {
      return tile.getImage(this.getLayer());
    }

    /**
     * Determine whether render should be called.
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */
  }, {
    key: "prepareFrame",
    value: function prepareFrame(frameState) {
      var layerRevision = this.getLayer().getRevision();
      if (this.renderedLayerRevision_ !== layerRevision) {
        this.renderedLayerRevision_ = layerRevision;
        this.renderedTiles.length = 0;
      }
      return _superPropGet(CanvasVectorTileLayerRenderer, "prepareFrame", this, 3)([frameState]);
    }

    /**
     * @param {import("../../VectorRenderTile.js").default} tile Tile.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../../proj/Projection.js").default} projection Projection.
     * @private
     */
  }, {
    key: "updateExecutorGroup_",
    value: function updateExecutorGroup_(tile, pixelRatio, projection) {
      var _this2 = this;
      var layer = /** @type {import("../../layer/VectorTile.js").default} */
      this.getLayer();
      var revision = layer.getRevision();
      var renderOrder = layer.getRenderOrder() || null;
      var resolution = tile.wantedResolution;
      var builderState = tile.getReplayState(layer);
      if (!builderState.dirty && builderState.renderedResolution === resolution && builderState.renderedRevision == revision && builderState.renderedRenderOrder == renderOrder) {
        return;
      }
      var source = layer.getSource();
      var declutter = !!layer.getDeclutter();
      var sourceTileGrid = source.getTileGrid();
      var tileGrid = source.getTileGridForProjection(projection);
      var tileExtent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
      var sourceTiles = source.getSourceTiles(pixelRatio, projection, tile);
      var layerUid = getUid(layer);
      delete tile.hitDetectionImageData[layerUid];
      tile.executorGroups[layerUid] = [];
      builderState.dirty = false;
      var _loop = function _loop() {
        var sourceTile = sourceTiles[t];
        if (sourceTile.getState() != TileState.LOADED) {
          return 1; // continue
        }
        var sourceTileCoord = sourceTile.tileCoord;
        var sourceTileExtent = sourceTileGrid.getTileCoordExtent(sourceTileCoord);
        var sharedExtent = getIntersection(tileExtent, sourceTileExtent);
        var builderExtent = buffer(sharedExtent, layer.getRenderBuffer() * resolution, _this2.tmpExtent);
        var bufferedExtent = equals(sourceTileExtent, sharedExtent) ? null : builderExtent;
        var builderGroup = new CanvasBuilderGroup(0, sharedExtent, resolution, pixelRatio);
        var squaredTolerance = getSquaredRenderTolerance(resolution, pixelRatio);

        /**
         * @param {import("../../Feature.js").FeatureLike} feature Feature.
         * @param {number} [index] Render order index.
         * @this {CanvasVectorTileLayerRenderer}
         */
        var render = function render(feature, index) {
          var styles;
          var styleFunction = feature.getStyleFunction() || layer.getStyleFunction();
          if (styleFunction) {
            styles = styleFunction(feature, resolution);
          }
          if (styles) {
            var dirty = this.renderFeature(feature, squaredTolerance, styles, builderGroup, declutter, index);
            builderState.dirty = builderState.dirty || dirty;
          }
        };
        var features = sourceTile.getFeatures();
        if (renderOrder && renderOrder !== builderState.renderedRenderOrder) {
          features.sort(renderOrder);
        }
        for (var i = 0, ii = features.length; i < ii; ++i) {
          var feature = features[i];
          if (!bufferedExtent || intersects(bufferedExtent, feature.getGeometry().getExtent())) {
            render.call(_this2, feature, i);
          }
        }
        var executorGroupInstructions = builderGroup.finish();
        // no need to clip when the render tile is covered by a single source tile
        var replayExtent = layer.getRenderMode() !== 'vector' && declutter && sourceTiles.length === 1 ? null : sharedExtent;
        var renderingReplayGroup = new CanvasExecutorGroup(replayExtent, resolution, pixelRatio, source.getOverlaps(), executorGroupInstructions, layer.getRenderBuffer(), true);
        tile.executorGroups[layerUid].push(renderingReplayGroup);
      };
      for (var t = 0, tt = sourceTiles.length; t < tt; ++t) {
        if (_loop()) continue;
      }
      builderState.renderedRevision = revision;
      builderState.renderedRenderOrder = renderOrder;
      builderState.renderedResolution = resolution;
    }

    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
     * @return {T|undefined} Callback result.
     * @template T
     */
  }, {
    key: "forEachFeatureAtCoordinate",
    value: function forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
      var resolution = frameState.viewState.resolution;
      var rotation = frameState.viewState.rotation;
      hitTolerance = hitTolerance == undefined ? 0 : hitTolerance;
      var layer = this.getLayer();
      var source = layer.getSource();
      var tileGrid = source.getTileGridForProjection(frameState.viewState.projection);
      var hitExtent = boundingExtent([coordinate]);
      buffer(hitExtent, resolution * hitTolerance, hitExtent);

      /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */
      var features = {};

      /**
       * @param {import("../../Feature.js").FeatureLike} feature Feature.
       * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
       * @param {number} distanceSq The squared distance to the click position.
       * @return {T|undefined} Callback result.
       */
      var featureCallback = function featureCallback(feature, geometry, distanceSq) {
        var key = feature.getId();
        if (key === undefined) {
          key = getUid(feature);
        }
        var match = features[key];
        if (!match) {
          if (distanceSq === 0) {
            features[key] = true;
            return callback(feature, layer, geometry);
          }
          matches.push(features[key] = {
            feature: feature,
            layer: layer,
            geometry: geometry,
            distanceSq: distanceSq,
            callback: callback
          });
        } else if (match !== true && distanceSq < match.distanceSq) {
          if (distanceSq === 0) {
            features[key] = true;
            matches.splice(matches.lastIndexOf(match), 1);
            return callback(feature, layer, geometry);
          }
          match.geometry = geometry;
          match.distanceSq = distanceSq;
        }
        return undefined;
      };
      var renderedTiles = /** @type {Array<import("../../VectorRenderTile.js").default>} */
      this.renderedTiles;
      var found;
      var _loop2 = function _loop2() {
        var tile = renderedTiles[i];
        var tileExtent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
        if (!intersects(tileExtent, hitExtent)) {
          return 1; // continue
        }
        var layerUid = getUid(layer);
        var executorGroups = [tile.executorGroups[layerUid]];
        var declutter = layer.getDeclutter();
        executorGroups.some(function (executorGroups) {
          var declutteredFeatures = declutter ? frameState.declutter[declutter].all().map(function (item) {
            return item.value;
          }) : null;
          for (var t = 0, tt = executorGroups.length; t < tt; ++t) {
            var executorGroup = executorGroups[t];
            found = executorGroup.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutteredFeatures);
            if (found) {
              return true;
            }
          }
        });
      };
      for (var i = 0, ii = renderedTiles.length; !found && i < ii; ++i) {
        if (_loop2()) continue;
      }
      return found;
    }

    /**
     * Asynchronous layer level hit detection.
     * @param {import("../../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../../Feature.js").FeatureLike>>} Promise that resolves with an array of features.
     */
  }, {
    key: "getFeatures",
    value: function getFeatures(pixel) {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        var layer = _this3.getLayer();
        var layerUid = getUid(layer);
        var source = layer.getSource();
        var projection = _this3.renderedProjection;
        var projectionExtent = projection.getExtent();
        var resolution = _this3.renderedResolution;
        var tileGrid = source.getTileGridForProjection(projection);
        var coordinate = applyTransform(_this3.renderedPixelToCoordinateTransform_, pixel.slice());
        var tileCoord = tileGrid.getTileCoordForCoordAndResolution(coordinate, resolution);
        /** @type {import("../../VectorRenderTile.js").default|undefined} */
        var tile;
        for (var i = 0, ii = _this3.renderedTiles.length; i < ii; ++i) {
          if (tileCoord.toString() === _this3.renderedTiles[i].tileCoord.toString()) {
            tile = /** @type {import("../../VectorRenderTile.js").default} */
            _this3.renderedTiles[i];
            if (tile.getState() === TileState.LOADED) {
              var _extent = tileGrid.getTileCoordExtent(tile.tileCoord);
              if (source.getWrapX() && projection.canWrapX() && !containsExtent(projectionExtent, _extent)) {
                wrapX(coordinate, projection);
              }
              break;
            }
            tile = undefined;
          }
        }
        if (!tile || tile.loadingSourceTiles > 0) {
          resolve([]);
          return;
        }
        var extent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
        var corner = getTopLeft(extent);
        var tilePixel = [(coordinate[0] - corner[0]) / resolution, (corner[1] - coordinate[1]) / resolution];
        /** @type {Array<import("../../Feature.js").FeatureLike>} */
        var features = tile.getSourceTiles().reduce(function (accumulator, sourceTile) {
          return accumulator.concat(sourceTile.getFeatures());
        }, []);
        /** @type {ImageData|undefined} */
        var hitDetectionImageData = tile.hitDetectionImageData[layerUid];
        if (!hitDetectionImageData) {
          var tileSize = toSize(tileGrid.getTileSize(tileGrid.getZForResolution(resolution, source.zDirection)));
          var rotation = _this3.renderedRotation_;
          var transforms = [_this3.getRenderTransform(tileGrid.getTileCoordCenter(tile.wrappedTileCoord), resolution, 0, HIT_DETECT_RESOLUTION, tileSize[0] * HIT_DETECT_RESOLUTION, tileSize[1] * HIT_DETECT_RESOLUTION, 0)];
          hitDetectionImageData = createHitDetectionImageData(tileSize, transforms, features, layer.getStyleFunction(), tileGrid.getTileCoordExtent(tile.wrappedTileCoord), tile.getReplayState(layer).renderedResolution, rotation);
          tile.hitDetectionImageData[layerUid] = hitDetectionImageData;
        }
        resolve(hitDetect(tilePixel, features, hitDetectionImageData));
      });
    }

    /**
     * Perform action necessary to get the layer rendered after new fonts have loaded
     */
  }, {
    key: "handleFontsChanged",
    value: function handleFontsChanged() {
      var layer = this.getLayer();
      if (layer.getVisible() && this.renderedLayerRevision_ !== undefined) {
        layer.changed();
      }
    }

    /**
     * Handle changes in image style state.
     * @param {import("../../events/Event.js").default} event Image style change event.
     * @private
     */
  }, {
    key: "handleStyleImageChange_",
    value: function handleStyleImageChange_(event) {
      this.renderIfReadyAndVisible();
    }

    /**
     * Render declutter items for this layer
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     * @param {import("../../layer/Layer.js").State} layerState Layer state.
     */
  }, {
    key: "renderDeclutter",
    value: function renderDeclutter(frameState, layerState) {
      var context = this.context;
      var alpha = context.globalAlpha;
      context.globalAlpha = layerState.opacity;
      var viewHints = frameState.viewHints;
      var hifi = !(viewHints[ViewHint.ANIMATING] || viewHints[ViewHint.INTERACTING]);
      var tiles = /** @type {Array<import("../../VectorRenderTile.js").default>} */
      this.renderedTiles;
      for (var i = 0, ii = tiles.length; i < ii; ++i) {
        var tile = tiles[i];
        var executorGroups = tile.executorGroups[getUid(this.getLayer())];
        var declutter = this.getLayer().getDeclutter();
        if (executorGroups) {
          for (var j = executorGroups.length - 1; j >= 0; --j) {
            executorGroups[j].execute(this.context, [this.context.canvas.width, this.context.canvas.height], this.getTileRenderTransform(tile, frameState), frameState.viewState.rotation, hifi, DECLUTTER, declutter ? frameState.declutter[declutter] : undefined);
          }
        }
      }
      context.globalAlpha = alpha;
    }

    /**
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     */
  }, {
    key: "renderDeferredInternal",
    value: function renderDeferredInternal(frameState) {
      var _this4 = this;
      var tiles = /** @type {Array<import("../../VectorRenderTile.js").default>} */
      this.renderedTiles;
      var executorGroups = tiles.reduce(function (acc, tile, index) {
        tile.executorGroups[getUid(_this4.getLayer())].forEach(function (executorGroup) {
          return acc.push({
            executorGroup: executorGroup,
            index: index
          });
        });
        return acc;
      }, []);
      var executorGroupZIndexContexts = executorGroups.map(function (_ref) {
        var executorGroup = _ref.executorGroup;
        return executorGroup.getDeferredZIndexContexts();
      });
      var usedZIndices = {};
      for (var i = 0, ii = executorGroups.length; i < ii; ++i) {
        var executorGroupZindexContext = executorGroups[i].executorGroup.getDeferredZIndexContexts();
        for (var key in executorGroupZindexContext) {
          usedZIndices[key] = true;
        }
      }
      var zIndexKeys = Object.keys(usedZIndices).sort(ascending);
      zIndexKeys.map(Number).forEach(function (zIndex) {
        executorGroupZIndexContexts.forEach(function (zIndexContexts, i) {
          if (!zIndexContexts[zIndex]) {
            return;
          }
          zIndexContexts[zIndex].forEach(function (zIndexContext) {
            var _executorGroups$i = executorGroups[i],
              executorGroup = _executorGroups$i.executorGroup,
              index = _executorGroups$i.index;
            var context = executorGroup.getRenderedContext();
            var alpha = context.globalAlpha;
            context.globalAlpha = _this4.renderedOpacity_;
            var tileClipContext = _this4.tileClipContexts_[index];
            if (tileClipContext) {
              tileClipContext.draw(context);
            }
            zIndexContext.draw(context);
            if (tileClipContext) {
              context.restore();
            }
            context.globalAlpha = alpha;
            zIndexContext.clear();
          });
          zIndexContexts[zIndex].length = 0;
        });
      });
    }
  }, {
    key: "getTileRenderTransform",
    value: function getTileRenderTransform(tile, frameState) {
      var pixelRatio = frameState.pixelRatio;
      var viewState = frameState.viewState;
      var center = viewState.center;
      var resolution = viewState.resolution;
      var rotation = viewState.rotation;
      var size = frameState.size;
      var width = Math.round(size[0] * pixelRatio);
      var height = Math.round(size[1] * pixelRatio);
      var source = this.getLayer().getSource();
      var tileGrid = source.getTileGridForProjection(frameState.viewState.projection);
      var tileCoord = tile.tileCoord;
      var tileExtent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
      var worldOffset = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent)[0] - tileExtent[0];
      var transform = multiply(scale(this.inversePixelTransform.slice(), 1 / pixelRatio, 1 / pixelRatio), this.getRenderTransform(center, resolution, rotation, pixelRatio, width, height, worldOffset));
      return transform;
    }

    /**
     * Render the vectors for this layer.
     * @param {CanvasRenderingContext2D} context Target context.
     * @param {import("../../Map.js").FrameState} frameState Frame state.
     */
  }, {
    key: "postRender",
    value: function postRender(context, frameState) {
      var viewHints = frameState.viewHints;
      var hifi = !(viewHints[ViewHint.ANIMATING] || viewHints[ViewHint.INTERACTING]);
      this.renderedPixelToCoordinateTransform_ = frameState.pixelToCoordinateTransform.slice();
      this.renderedRotation_ = frameState.viewState.rotation;
      this.renderedOpacity_ = frameState.layerStatesArray[frameState.layerIndex].opacity;
      var layer = /** @type {import("../../layer/VectorTile.js").default} */
      this.getLayer();
      var renderMode = layer.getRenderMode();
      var alpha = context.globalAlpha;
      context.globalAlpha = this.renderedOpacity_;
      var declutter = layer.getDeclutter();
      var replayTypes = declutter ? VECTOR_REPLAYS[renderMode].filter(function (type) {
        return !DECLUTTER.includes(type);
      }) : VECTOR_REPLAYS[renderMode];
      var viewState = frameState.viewState;
      var rotation = viewState.rotation;
      var tileSource = layer.getSource();
      var tileGrid = tileSource.getTileGridForProjection(viewState.projection);
      var z = tileGrid.getZForResolution(viewState.resolution, tileSource.zDirection);
      var tiles = this.renderedTiles;
      var clips = [];
      var clipZs = [];
      var tileClipContexts = [];
      var ready = true;
      for (var i = tiles.length - 1; i >= 0; --i) {
        var tile = /** @type {import("../../VectorRenderTile.js").default} */
        tiles[i];
        ready = ready && !tile.getReplayState(layer).dirty;
        var executorGroups = tile.executorGroups[getUid(layer)].filter(function (group) {
          return group.hasExecutors(replayTypes);
        });
        if (executorGroups.length === 0) {
          continue;
        }
        var transform = this.getTileRenderTransform(tile, frameState);
        var currentZ = tile.tileCoord[0];
        var contextSaved = false;
        // Clip mask for regions in this tile that already filled by a higher z tile
        var currentClip = executorGroups[0].getClipCoords(transform);
        var clipContext = context;
        var tileClipContext = void 0;
        if (currentClip) {
          tileClipContext = new ZIndexContext();
          clipContext = tileClipContext.getContext();
          for (var j = 0, jj = clips.length; j < jj; ++j) {
            if (z !== currentZ && currentZ < clipZs[j]) {
              var clip = clips[j];
              if (intersects([currentClip[0], currentClip[3], currentClip[4], currentClip[7]], [clip[0], clip[3], clip[4], clip[7]])) {
                if (!contextSaved) {
                  clipContext.save();
                  contextSaved = true;
                }
                clipContext.beginPath();
                // counter-clockwise (outer ring) for current tile
                clipContext.moveTo(currentClip[0], currentClip[1]);
                clipContext.lineTo(currentClip[2], currentClip[3]);
                clipContext.lineTo(currentClip[4], currentClip[5]);
                clipContext.lineTo(currentClip[6], currentClip[7]);
                // clockwise (inner ring) for higher z tile
                clipContext.moveTo(clip[6], clip[7]);
                clipContext.lineTo(clip[4], clip[5]);
                clipContext.lineTo(clip[2], clip[3]);
                clipContext.lineTo(clip[0], clip[1]);
                clipContext.clip();
              }
            }
          }
          clips.push(currentClip);
          clipZs.push(currentZ);
        }
        for (var t = 0, tt = executorGroups.length; t < tt; ++t) {
          var _frameState$declutter;
          var executorGroup = executorGroups[t];
          executorGroup.execute(context, [context.canvas.width, context.canvas.height], transform, rotation, hifi, replayTypes, (_frameState$declutter = frameState.declutter) === null || _frameState$declutter === void 0 ? void 0 : _frameState$declutter[declutter]);
        }
        if (contextSaved) {
          if (clipContext === context) {
            clipContext.restore();
          } else {
            tileClipContexts[i] = tileClipContext;
          }
        }
      }
      context.globalAlpha = alpha;
      this.ready = ready;
      this.tileClipContexts_ = tileClipContexts;
      if (!frameState.declutter) {
        this.renderDeferredInternal(frameState);
      }
      _superPropGet(CanvasVectorTileLayerRenderer, "postRender", this, 3)([context, frameState]);
    }

    /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
     * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
     * @param {boolean} [declutter] Enable decluttering.
     * @param {number} [index] Render order index.
     * @return {boolean} `true` if an image is loading.
     */
  }, {
    key: "renderFeature",
    value: function renderFeature(feature, squaredTolerance, styles, builderGroup, declutter, index) {
      if (!styles) {
        return false;
      }
      var loading = false;
      if (Array.isArray(styles)) {
        for (var i = 0, ii = styles.length; i < ii; ++i) {
          loading = _renderFeature(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, undefined, declutter, index) || loading;
        }
      } else {
        loading = _renderFeature(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, undefined, declutter, index);
      }
      return loading;
    }

    /**
     * @param {import("../../VectorRenderTile.js").default} tile Tile.
     * @return {boolean} A new tile image was rendered.
     * @private
     */
  }, {
    key: "tileImageNeedsRender_",
    value: function tileImageNeedsRender_(tile) {
      var layer = /** @type {import("../../layer/VectorTile.js").default} */
      this.getLayer();
      if (layer.getRenderMode() === 'vector') {
        return false;
      }
      var replayState = tile.getReplayState(layer);
      var revision = layer.getRevision();
      var resolution = tile.wantedResolution;
      return replayState.renderedTileResolution !== resolution || replayState.renderedTileRevision !== revision;
    }

    /**
     * @param {import("../../VectorRenderTile.js").default} tile Tile.
     * @param {import("../../Map").FrameState} frameState Frame state.
     * @private
     */
  }, {
    key: "renderTileImage_",
    value: function renderTileImage_(tile, frameState) {
      var layer = /** @type {import("../../layer/VectorTile.js").default} */
      this.getLayer();
      var replayState = tile.getReplayState(layer);
      var revision = layer.getRevision();
      var executorGroups = tile.executorGroups[getUid(layer)];
      replayState.renderedTileRevision = revision;
      var tileCoord = tile.wrappedTileCoord;
      var z = tileCoord[0];
      var source = layer.getSource();
      var pixelRatio = frameState.pixelRatio;
      var viewState = frameState.viewState;
      var projection = viewState.projection;
      var tileGrid = source.getTileGridForProjection(projection);
      var tileResolution = tileGrid.getResolution(tile.tileCoord[0]);
      var renderPixelRatio = frameState.pixelRatio / tile.wantedResolution * tileResolution;
      var resolution = tileGrid.getResolution(z);
      var context = tile.getContext(layer);

      // Increase tile size when overzooming for low pixel ratio, to avoid blurry tiles
      pixelRatio = Math.round(Math.max(pixelRatio, renderPixelRatio / pixelRatio));
      var size = source.getTilePixelSize(z, pixelRatio, projection);
      context.canvas.width = size[0];
      context.canvas.height = size[1];
      var renderScale = pixelRatio / renderPixelRatio;
      if (renderScale !== 1) {
        var canvasTransform = resetTransform(this.tmpTransform_);
        scaleTransform(canvasTransform, renderScale, renderScale);
        context.setTransform.apply(context, canvasTransform);
      }
      var tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent);
      var pixelScale = renderPixelRatio / resolution;
      var transform = resetTransform(this.tmpTransform_);
      scaleTransform(transform, pixelScale, -pixelScale);
      translateTransform(transform, -tileExtent[0], -tileExtent[3]);
      for (var i = 0, ii = executorGroups.length; i < ii; ++i) {
        var executorGroup = executorGroups[i];
        executorGroup.execute(context, [context.canvas.width * renderScale, context.canvas.height * renderScale], transform, 0, true, IMAGE_REPLAYS[layer.getRenderMode()], null);
      }
      replayState.renderedTileResolution = tile.wantedResolution;
    }
  }]);
}(CanvasTileLayerRenderer);
export default CanvasVectorTileLayerRenderer;